import React, {useState} from 'react'
import {GoogleMap, Marker, useJsApiLoader, InfoWindow} from '@react-google-maps/api';
import pin1 from "../../../resources/images/pin-animeted.svg";
import ShippingIcon from "../../../resources/icons/ShippingIcon";
import {getWebPathParam} from "../../../utils/converter";
import {LOGISTICS, SHIPPING, SHIPPING_DETAIL} from "../../../routes/endpoints";
import CustomerIcon from "../../../resources/icons/CustomerIcon";
import {LocationMarkerIcon} from "@heroicons/react/outline";

function FullMapMarkers({ positions, zoom, height }) {

    const pos= positions.filter(r => r.location);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [center, setCenter] = useState(pos[0] ? pos[0].location : { lat: 0, lng: 0 });



    const containerStyle = {
        width: '100%',
        height: height+'px'
    };

    const customStyle = [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#6195a0" } ] }, { "featureType": "administrative.province", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "lightness": "0" }, { "saturation": "0" }, { "color": "#f5f5f2" }, { "gamma": "1" } ] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [ { "lightness": "-3" }, { "gamma": "1.00" } ] }, { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [ { "color": "#bae5ce" }, { "visibility": "on" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 }, { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#fac9a9" }, { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "labels.text", "stylers": [ { "color": "#4e4e4e" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [ { "color": "#787878" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit.station.airport", "elementType": "labels.icon", "stylers": [ { "hue": "#0a00ff" }, { "saturation": "-77" }, { "gamma": "0.57" }, { "lightness": "0" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.text.fill", "stylers": [ { "color": "#43321e" } ] }, { "featureType": "transit.station.rail", "elementType": "labels.icon", "stylers": [ { "hue": "#ff6c00" }, { "lightness": "4" }, { "gamma": "0.75" }, { "saturation": "-68" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#eaf6f8" }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#c7eced" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "lightness": "-49" }, { "saturation": "-53" }, { "gamma": "0.79" } ] } ];

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyAAaeOxwq7lUxrmIRYcoW32CDyGRRL8Uwo"
    })

    // eslint-disable-next-line
    const [map, setMap] = useState(null)

    const onLoad = React.useCallback(function callback(map) {
        //const bounds = new window.google.maps.LatLngBounds(center);
        //map.fitBounds(bounds);
        map.setZoom(zoom)
        setMap(map)
        // eslint-disable-next-line
    }, [])


    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded ? (
        <>
            <GoogleMap
                mapContainerClassName={'map-marker'}
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoom}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={{
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                    styles: customStyle,
                }}
            >

                {pos.map((position) => (
                    <Marker
                        icon={{
                            url: pin1,
                            scaledSize: new window.google.maps.Size(26, 26),
                            anchor: new window.google.maps.Point(13, 13),
                        }}
                        key={position.id}
                        position={position.location}
                        onClick={() => {
                            setSelectedLocation(position);
                            setCenter(position.location);
                        }}
                    />
                ))}

                {selectedLocation && (
                    <InfoWindow
                        position={{ lat: selectedLocation.location.lat, lng: selectedLocation.location.lng }}
                        onCloseClick={() => {
                            setSelectedLocation(null);
                        }}
                    >
                        <div className={'px-4 py-1'}>

                            <div className={"flex  flex-col items-center "}>

                                <div className="mb-2">
                                    <ShippingIcon className={'w-5 h-5 text-blue-1000'} />
                                </div>
                                <div className="border-b border-b-2 border-blue-1000 mb-2">
                                    <div className="text-md font-semibold text-blue-1000 uppercase">
                                        {selectedLocation.shipping_map_info.vessel_name}
                                    </div>
                                </div>


                                <div className="mb-2">
                                    <CustomerIcon className={'w-5 h-5 text-blue-1000'} />
                                </div>

                                <div className="border-b border-b-2 border-blue-1000 mb-1">
                                    <div className="text-md font-semibold text-blue-1000 uppercase">
                                        {selectedLocation.shipping_map_info.customer.business_name}
                                    </div>
                                </div>
                                <a rel="noreferrer"
                                    href={getWebPathParam([LOGISTICS, SHIPPING, selectedLocation.shipping_map_info.id, SHIPPING_DETAIL])}
                                   target="_blank"
                                   className="text-sm text-blue-1000 underline font-semibold ">
                                    #{selectedLocation.shipping_map_info.tracking}
                                </a>

                            </div>
                        </div>
                    </InfoWindow>
                )}
            </GoogleMap>
        </>
    ) : <>
        <div className="border bg-solitude-400   p-4 w-full mx-auto  flex before:flex-1 after:flex-1 flex-col items-center" style={{height: height+'px'}}>
            <div className="animate-pulse border border-gray-500 rounded-full p-4">
                <LocationMarkerIcon className="text-gray-500 h-6 w-6 stroke-current stroke-1" />
            </div>
        </div>
    </>
}



export default FullMapMarkers;
